import React, { useState, useEffect } from "react";
import { get, groupBy } from "lodash";
import { FormattedMessage } from "react-intl";
import { Container, Loader, Header, Icon, Grid } from "semantic-ui-react";
import AttachmentCards from "./AttachmentCards";
import "./attachments.scss";
import { I18nShape } from "../../../shared/shapes/i18n.shape";
import { AccountShape } from "../../../shared/shapes";
import { DEPRECATED_PageContentShape } from "../../../shared/shapes/deprecated_pageContent.shape";

function Attachments(props) {
  const [isLoading, setIsLoading] = useState(false);

  const { account, pageContent, i18n } = props;
  const attachments = get(pageContent, "attachments");

  useEffect(() => {
    if (!account) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [account]);
  if (isLoading) {
    return <Loader active />;
  }

  const groupedAttachments = groupBy(attachments, attachment => {
    return attachment.role;
  });

  const attachmentTypes =
    get(account, ["config", "attachment_types"]) ||
    get(pageContent, ["attachment_types"], []);

  const groups = attachmentTypes.reduce((accu, attachmentType) => {
    const attachmentsForType = groupedAttachments[attachmentType.id];

    if (attachmentsForType?.length > 0) {
      accu.push(
        <div key={attachmentType.id} data-component="attachmentGroup">
          <Header>
            <Icon name="folder open outline" /> {attachmentType.label}
          </Header>
          <AttachmentCards
            i18n={i18n}
            attachments={attachmentsForType}
            attachmentsPerRow={4}
          />
        </div>
      );
    }

    return accu;
  }, []);

  return (
    <Container data-component="attachments">
      <Header size="large">
        <FormattedMessage
          id="buyerPortal.attachments.header"
          defaultText="buyerPortal.attachments.header"
        />
      </Header>
      <Grid>
        <Grid.Column width={16} verticalAlign="middle">
          {groups}
          {attachments && attachments.length === 0 && (
            <div>
              <FormattedMessage
                id="buyerPortal.attachments.noResults"
                defaultText="buyerPortal.attachments.noResults"
              />
            </div>
          )}
        </Grid.Column>
      </Grid>
    </Container>
  );
}

Attachments.defaultProps = {
  pageContent: {}
};

Attachments.propTypes = {
  i18n: I18nShape.isRequired,
  pageContent: DEPRECATED_PageContentShape,
  account: AccountShape.isRequired
};

export default Attachments;
